<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .license-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: utils.in_rem(12px) 0;
    border-bottom: 1px solid colors.get(interfaceSwGrey_10);

    &:last-child {
      border-bottom: none;
    }
  }
</style>

<script>
  import Checkbox from "@sourcewhale/shared/svelte-design-system/components/atoms/Checkbox/Checkbox.svelte";
  import { selectedLicenses, updateLicenseSelection } from "../stores";
  import LicenseInfo from "./LicenseInfo.svelte";

  let { mod, licenseInfo } = $props();

  let available = $derived(licenseInfo.available);
  let remaining = $derived(licenseInfo.remaining);

  let disabled = $derived(!available && !$selectedLicenses[mod.kind]);
  const getChecked = () => $selectedLicenses[mod.kind] || false;
  const setChecked = (v) => updateLicenseSelection(mod.kind, v);
</script>

<div class="license-row">
  <LicenseInfo {mod} {available} {remaining} {disabled} />
  <Checkbox bind:checked={getChecked, setChecked} {disabled} />
</div>
